/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { UpdateManualEnumerationInputDto } from './UpdateManualEnumerationInputDto';
import {
    instanceOfUpdateManualEnumerationInputDto,
    UpdateManualEnumerationInputDtoFromJSON,
    UpdateManualEnumerationInputDtoFromJSONTyped,
    UpdateManualEnumerationInputDtoToJSON,
} from './UpdateManualEnumerationInputDto';
import type { UpdateManualNumericInputDto } from './UpdateManualNumericInputDto';
import {
    instanceOfUpdateManualNumericInputDto,
    UpdateManualNumericInputDtoFromJSON,
    UpdateManualNumericInputDtoFromJSONTyped,
    UpdateManualNumericInputDtoToJSON,
} from './UpdateManualNumericInputDto';
import type { UpdateStateDto } from './UpdateStateDto';
import {
    instanceOfUpdateStateDto,
    UpdateStateDtoFromJSON,
    UpdateStateDtoFromJSONTyped,
    UpdateStateDtoToJSON,
} from './UpdateStateDto';

/**
 * @type UpdateResultDto
 * 
 * @export
 */
export type UpdateResultDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared' } & UpdateManualEnumerationInputDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared' } & UpdateManualNumericInputDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateStateDto, Ptw.Ptw100.AppZero.Application.Shared' } & UpdateStateDto;


export function UpdateResultDtoFromJSON(json: any): UpdateResultDto {
    return UpdateResultDtoFromJSONTyped(json, false);
}

export function UpdateResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateResultDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, UpdateManualEnumerationInputDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, UpdateManualNumericInputDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateStateDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, UpdateStateDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateStateDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of UpdateResultDto exists with '$type=${json['$type']}'`);
    }
}

export function UpdateResultDtoToJSON(value?: UpdateResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualEnumerationInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return UpdateManualEnumerationInputDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared':
            return UpdateManualNumericInputDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateStateDto, Ptw.Ptw100.AppZero.Application.Shared':
            return UpdateStateDtoToJSON(value);
        default:
            throw new Error(`No variant of UpdateResultDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the UpdateResultDto interface.
 */
export function instanceOfUpdateResultDto(value: any): value is UpdateResultDto {
    if (instanceOfUpdateManualEnumerationInputDto(value)) return true;
    if (instanceOfUpdateManualNumericInputDto(value)) return true;
    if (instanceOfUpdateStateDto(value)) return true;
    return false;
}

